module.exports = __webpack_public_path__ + "static/media/organization-un-active.d88a3287.svg";